/**
 * Pixi re-exported from its PREBUNDLED dist build.
 *
 * Bun's bundler mis-orders PixiJS v8's modular `lib/` entry: top-level
 * `extensions.add(...)` registration runs before the extensions registry is
 * initialised, throwing "CI is not defined" at runtime (both dev and prod).
 * Pixi's `dist/pixi.mjs` is a single pre-resolved bundle, so Bun includes it
 * verbatim and the init order is preserved. Values come from that bundle; types
 * come from the `pixi.js` package proper (so callers stay fully typed).
 *
 * If/when Bun fixes the bundler ordering, delete this shim and import from
 * 'pixi.js' directly again.
 */
// @ts-expect-error — the prebundled .mjs has no co-located .d.ts; typed via the cast below.
import * as distPixi from '../../node_modules/pixi.js/dist/pixi.mjs';

const PIXI = distPixi as typeof import('pixi.js');

// Each symbol is exported as a value (from the prebundle) AND a same-named type
// (from the package) — the value/type-space merge a `class` gives you for free.
export const Application = PIXI.Application;
export const Container = PIXI.Container;
export const Graphics = PIXI.Graphics;
export const Sprite = PIXI.Sprite;
export const TilingSprite = PIXI.TilingSprite;
export const Texture = PIXI.Texture;
export const TextureSource = PIXI.TextureSource;
export const Text = PIXI.Text;
export const Assets = PIXI.Assets;
export type Application = import('pixi.js').Application;
export type Container = import('pixi.js').Container;
export type Graphics = import('pixi.js').Graphics;
export type Sprite = import('pixi.js').Sprite;
export type TilingSprite = import('pixi.js').TilingSprite;
export type Texture = import('pixi.js').Texture;
export type TextureSource = import('pixi.js').TextureSource;
export type Text = import('pixi.js').Text;
